import { useContext, useState, useEffect } from "react";
import { StandardButton } from "../atoms/buttons";
import { LogComp } from "../components/logComp";
import { ProfileComp } from "../components/profileComp";
import { TitleInput } from "../components/titleInput";
import { TopNavSetting } from "../components/topNavigationSettings";
import { TopBar } from "../components/topbar";
import { ProfileSetting } from "../components/profileSettingComp";
import { SecuritySetting } from "../components/securitySettingComp";
import { NotificationSetting } from "../components/notificationSettingComp";
import { BillingSettingComp } from "../components/billingSettingComp";
import { SettingFactory } from "../factory/settingFactor";
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import Tabs from "../components/tabs";
import { UserContext } from "../App";
import { HeaderTitle } from "../molecule/headerTitle";
import { useFeatures } from "../FeaturesContext";

export function Settings({ pageSwap }) {
  const [activeSetting, setActiveSetting] = useState(1);
  const userContext = useContext(UserContext)
  const isPublic = userContext.account_type === 1
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { isFeatureEnabled } = useFeatures();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const departmentTitle = isPublic ? "Doelgroepen" : "Afdelingen";
  var pages = [{"id": 1, "title": "Profiel"}, {"id": 10, "title": "Afbeeldingstemplates"}, {"id": 2, "title": "Beveiliging"}, {"id": 4, "title": "Meldingen"}, isPublic ? false : {"id": 5, "title": "Rechten"}, isPublic ? false : {"id": 11, "title": "Linkedin"}, isPublic ? false : {"id": 6, "title": "Klanten"}, {"id":7, "title": departmentTitle}].filter(Boolean);
  if (isFeatureEnabled(20)) { pages.push({"id":8,"title":"Thema"}) };
  if (isFeatureEnabled(24)) { pages.push({"id":9,"title":"Modus"}) };
  if (isFeatureEnabled(28)) { pages.push({"id":9,"title":"Modus"}) };
  pages.push({"id":11,"title":"Linkedin"}) ;
  
  if (!userContext.permissions.includes("courses.manage")) {
    pages = pages.filter((page) => page.id !== 10);
  }

  if (!userContext.permissions.includes("company.roles.manage")) {
    pages = pages.filter((page) => page.id !== 5);
  }
  if (!userContext.permissions.includes("settings.manage.theme")) {
    pages = pages.filter((page) => page.id !== 8);
  }
  if (!userContext.permissions.includes("reseller.view")) {
    pages = pages.filter((page) => page.id !== 6);
  }
  if (!userContext.permissions.includes("settings.manage.departments")) {
    pages = pages.filter((page) => page.id !== 7);
  }


  return (
    <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
       <HeaderTitle className={"standard-margin phone-settings-title"} title={"Instellingen"}/>
       <VerticalLayout className="standard-padding standard-rounded standard-margin card-background-color phone-settings" style={{ width: "unset", height: "unset", padding:0 }}>
        <HorizontalLayout  style={{ overflowX: isMobile ? "auto" : "hidden",  whiteSpace: isMobile ? "nowrap" : "normal", display: "flex",height:"100%"}}>
          <Tabs selectedTab={activeSetting} tabs={pages} onTabClick={setActiveSetting} />
         </HorizontalLayout>
        <SettingFactory setting={activeSetting} />
      </VerticalLayout>
    </VerticalPageLayout>
  );
}